import {Routes} from "@angular/router";
import {DashboardPaths} from "@shared/enum";
import {CanConstructorActivate, CanConstructorDeactivate} from "@pages/dashboard";

const DashboardComponent = () => import("@pages/dashboard/ui/dashboard/dashboard.component").then(m => m.DashboardComponent);
const WidgetConstructorComponent = () => import("@pages/dashboard/ui/widget-constructor-page/widget-constructor-page.component").then(m => m.WidgetConstructorPageComponent);

export const dashboardRoutes: Routes = [
    {
        path: DashboardPaths.DASHBOARD,
        loadComponent: DashboardComponent,
    },
    {
        path: `${DashboardPaths.CONSTRUCTOR}/:id`,
        loadComponent: WidgetConstructorComponent,
        canActivate: [CanConstructorActivate],
        canDeactivate: [CanConstructorDeactivate]
    },
];
